import { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';

import { Button } from '~/components/Button';
import { Modal } from '~/components/Modal';
import { useModal } from '~/features/modals/useModal';
import { buildTestId } from '~/utils/buildTestId';

type CareTeamIdInformationModalProps = {
  testID: string;
};

export const CareTeamIdInformationModal = ({
  testID,
}: CareTeamIdInformationModalProps) => {
  const { closeModal } = useModal();

  const onClose = useCallback(() => {
    closeModal('CareTeamIdInformation');
  }, [closeModal]);

  const onOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Modal
      testID={testID}
      title="Care team ID"
      hasCloseButton
      size="l"
      onOpenChange={onOpenChange}
    >
      <Text type="$bodyBase.default" paddingVertical="$4">
        The Care team ID is a unique identifier that can be provided to patients
        so that they can connect their mobile app to your department. You can
        use the automatically generated Care team ID or create a custom one.
      </Text>
      <Stack alignItems="center" width="100%">
        <Button
          variant="primary"
          onPress={onClose}
          label="Done"
          width="large"
          testID={buildTestId({
            testID,
            suffix: ['primary', 'action'],
          })}
        />
      </Stack>
    </Modal>
  );
};
